export const messages = {
  editor: {
    helpText: {
      id: 'admin/promotions.form.regular.editor.benefit.percentual-loyalty.help-text',
    },
    ariaLabel: {
      id: 'admin/promotions.form.regular.editor.benefit.percentual-loyalty.aria-label',
    },
    moreInformation: {
      id: 'admin/promotions.form.regular.editor.benefit.percentual-loyalty.more-information',
    },
  },
  view: {
    title: {
      id: 'admin/promotions.form.regular.view.benefit.percentual-loyalty.title',
    },
  },
  validation: {
    greaterThan: {
      id: 'admin/promotions.form.validation.greater-than',
    },
    required: {
      id: 'admin/promotions.form.validation.required',
    },
    lessThanOrEquals: {
      id: 'admin/promotions.form.validation.less-than-equals',
    },
  },
}
